import {
    AnyAction,
    ListenerMiddlewareInstance,
    ThunkDispatch,
} from '@reduxjs/toolkit';
import { BrowserPersistenceApi } from '@Data/browserPersistence/Api';
import { QualityControlActions } from '@Data/qualityControl/Reducer';
import { RootState } from './Store';

export const initializeListeners = (
    listenerMiddleware: ListenerMiddlewareInstance<
        unknown,
        ThunkDispatch<unknown, unknown, AnyAction>,
        unknown
    >
) => {
    // update the persisted qc pole when a pole updates
    listenerMiddleware.startListening({
        actionCreator: QualityControlActions.updateSelectedAnalysisEntity,
        effect: async (action, listenerApi) => {
            const entityVersionId = action.payload.entity.entity_version_id;

            const updatedQcPole = (
                listenerApi.getState() as RootState
            ).qualityControl.analysisEntities.find(
                (p) => p.entity_version_id === entityVersionId
            );
            const selectedFolderId = (listenerApi.getState() as RootState)
                .folder.selectedFolderId;

            BrowserPersistenceApi.updatePersistedPole(selectedFolderId, {
                entity_version_id: updatedQcPole.entity_version_id,
                qcState: updatedQcPole.qcState,
                reworkReasons: updatedQcPole.reworkReasons,
            });
        },
    });

    // set the persisted current qc pole when it is set in qc slice
    listenerMiddleware.startListening({
        actionCreator: QualityControlActions.setSelectedAnalysisEntity,
        effect: async (action, listenerApi) => {
            const selectedFolderId = (listenerApi.getState() as RootState)
                .folder.selectedFolderId;

            BrowserPersistenceApi.setSelectedQcPole(
                selectedFolderId,
                action.payload.entity_version_id
            );
        },
    });
};
